
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'

type Props = {
  isExpanded: boolean
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>
}


function ExpandCollapseIcon({
  isExpanded,
  setIsExpanded
}: Props) {

  return <div 
  className={`bg-gray-300 hover:opacity-80 p-4 cursor-pointer max-w-6 max-h-6 rounded-full flex items-center justify-center text-brand-blue text-2xl font-righteous
    ${isExpanded ? ' rotate-90 ' : ''}
    `}
   onClick={() => setIsExpanded(!isExpanded)}>
    &gt;
  </div>
}

export default ExpandCollapseIcon